import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

export const HeadlineSubtitle = ({
    headline,
    headlineTag = 'h1',
    headlineColor = 'black.100',
    subtitle,
    subtitleTag = 'h2',
    subtitleColor = 'black.100'
}) => {
    if (!headline && !subtitle) {
        return null
    }

    return (
        <Stack gap="15px" maxWidth="700px">
            {headline && (
                <Text as={headlineTag} color={headlineColor} textStyle="h1">
                    {headline}
                </Text>
            )}
            {subtitle && (
                <Text as={subtitleTag} color={subtitleColor} textStyle="p">
                    {subtitle}
                </Text>
            )}
        </Stack>
    )
}

HeadlineSubtitle.propTypes = {
    headline: PropTypes.string,
    subtitle: PropTypes.string,
    headlineTag: PropTypes.string,
    subtitleTag: PropTypes.string,
    headlineColor: PropTypes.string,
    subtitleColor: PropTypes.string
}

export default HeadlineSubtitle
